var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#DFDEE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5778 10.069C14.6682 10.069 14.7135 10.0163 14.7361 9.9334C14.9696 8.6753 14.9545 8.64518 16.2653 8.39655C16.3557 8.38151 16.4085 8.32876 16.4085 8.23835C16.4085 8.14796 16.3557 8.09521 16.2653 8.08014C14.9621 7.8165 14.9997 7.78635 14.7361 6.54333C14.7135 6.46046 14.6682 6.40771 14.5778 6.40771C14.4874 6.40771 14.4422 6.46046 14.4196 6.54333C14.156 7.78635 14.2012 7.8165 12.8903 8.08014C12.8075 8.09521 12.7472 8.14796 12.7472 8.23835C12.7472 8.32876 12.8075 8.38151 12.8903 8.39655C14.2012 8.66025 14.1861 8.6753 14.4196 9.9334C14.4422 10.0163 14.4874 10.069 14.5778 10.069ZM10.9317 15.252C11.0748 15.252 11.1727 15.1616 11.1878 15.026C11.459 13.0146 11.5268 13.0146 13.606 12.6153C13.7417 12.5927 13.8396 12.5023 13.8396 12.3592C13.8396 12.2236 13.7417 12.1256 13.606 12.103C11.5268 11.8168 11.4514 11.749 11.1878 9.69985C11.1727 9.56427 11.0748 9.46633 10.9317 9.46633C10.796 9.46633 10.6981 9.56427 10.683 9.7074C10.4344 11.7264 10.3289 11.7188 8.2648 12.103C8.12919 12.1332 8.03125 12.2236 8.03125 12.3592C8.03125 12.5098 8.12919 12.5927 8.29492 12.6153C10.344 12.9468 10.4344 12.9995 10.683 15.011C10.6981 15.1616 10.796 15.252 10.9317 15.252ZM16.0394 23.5916C16.2352 23.5916 16.3784 23.4485 16.416 23.2451C16.9509 19.1167 17.531 18.4914 21.6141 18.0394C21.8251 18.0168 21.9682 17.8586 21.9682 17.6628C21.9682 17.4669 21.8251 17.3162 21.6141 17.2861C17.531 16.8341 16.9509 16.2088 16.416 12.0804C16.3784 11.877 16.2352 11.7414 16.0394 11.7414C15.8435 11.7414 15.7003 11.877 15.6702 12.0804C15.1353 16.2088 14.5477 16.8341 10.4721 17.2861C10.2536 17.3162 10.1105 17.4669 10.1105 17.6628C10.1105 17.8586 10.2536 18.0168 10.4721 18.0394C14.5402 18.5743 15.1052 19.1243 15.6702 23.2451C15.7003 23.4485 15.8435 23.5916 16.0394 23.5916Z",
    fill: "url(#paint0_linear_8697_16892)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8697_16892",
    x1: 14.9997,
    y1: 6.40771,
    x2: 14.9997,
    y2: 23.5916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#55489E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#844FCE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsCircle);
export default __webpack_public_path__ + "static/media/stars-circle.705b4968.svg";
export { ForwardRef as ReactComponent };